module.exports = __webpack_public_path__ + "img/artificial_intelligence_flatline1.2c7368a0.svg";